import {
  GET_CATEGORIES_SUBCATEGORIES,
  GET_CATEGORIES_SUBCATEGORIES_FAIL,
  GET_CATEGORIES_SUBCATEGORIES_SUCCESS,

  ADD_NEW_ITEM,
  ADD_NEW_ITEM_SUCCESS,
  ADD_NEW_ITEM_FAIL,

  EDIT_ITEM,
  EDIT_ITEM_SUCCESS,
  EDIT_ITEM_FAIL,

  DELETE_ITEM,
  DELETE_ITEM_SUCCESS,
  DELETE_ITEM_FAIL,

  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAIL,

  GET_LEDGER_DETAILS,
  GET_LEDGER_DETAILS_SUCCESS,
  GET_LEDGER_DETAILS_FAIL,
  
  RESET_ERROR_AND_RESP,
  SET_TIMER,

  GET_HSNS,
  GET_HSNS_SUCCESS,
  GET_HSNS_FAIL,

  GET_UNITS,
  GET_UNITS_SUCCESS,
  GET_UNITS_FAIL,

  GET_ALLCOA,
  GET_ALLCOA_SUCCESS,
  GET_ALLCOA_FAIL,
  
  GET_ALL_PRODUCTS,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_FAIL,

  GET_PRODUCT_FOR_EDIT,
  GET_PRODUCT_FOR_EDIT_SUCCESS,
  GET_PRODUCT_FOR_EDIT_FAIL,

  GET_MANUFACTURERS,
  GET_MANUFACTURERS_SUCCESS,
  GET_MANUFACTURERS_FAIL,

  GET_TAXES,
  GET_TAXES_SUCCESS,
  GET_TAXES_FAIL,

  GET_BRANDS,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_FAIL,

  GET_SUPPLIERS,
  GET_SUPPLIERS_SUCCESS,
  GET_SUPPLIERS_FAIL,

  GET_ALL_CUSTOMERS,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_ALL_CUSTOMERS_FAIL,

  GET_ALL_EMPLOYEES,
  GET_ALL_EMPLOYEES_SUCCESS,
  GET_ALL_EMPLOYEES_FAIL,
  
  GET_ALL_BANKS,
  GET_ALL_BANKS_SUCCESS,
  GET_ALL_BANKS_FAIL,
  
  GET_SIZES,
  GET_SIZES_SUCCESS,
  GET_SIZES_FAIL,

  GET_COLOURS,
  GET_COLOURS_SUCCESS,
  GET_COLOURS_FAIL,

  ADD_NEW_MAJOR_ITEM,
  ADD_NEW_MAJOR_ITEM_SUCCESS,
  ADD_NEW_MAJOR_ITEM_FAIL,
} from "./actionTypes"


export const getLedgerDetails = (type, fromCache) => {
  return {
    type: GET_LEDGER_DETAILS,
    payload: { type },
    fromCache: fromCache
  }
}

export const getLedgerDetailsSuccess = response => {
  return {
    type: GET_LEDGER_DETAILS_SUCCESS,
    payload: response,
  }
}

export const getLedgerDetailsFail = error => {
  return {
    type: GET_LEDGER_DETAILS_FAIL,
    payload: error,
  }
}

export const getStoreSettings = (fromCache) => {
  return {
    type: GET_SETTINGS,
    payload: fromCache,
  }
}

export const getStoreSettingsSuccess = settings => ({
  type: GET_SETTINGS_SUCCESS,
  payload: settings,
})

export const getStoreSettingsFail = error => ({
  type: GET_SETTINGS_FAIL,
  payload: error,
})

export const getAllSizes = (fromCache) => ({
  type: GET_SIZES,
  payload: fromCache
})

export const getAllSizesSuccess = sizes => ({
  type: GET_SIZES_SUCCESS,
  payload: sizes,
})

export const getAllSizesFail = error => ({
  type: GET_SIZES_FAIL,
  payload: error,
})

export const getAllColours = (fromCache) => ({
  type: GET_COLOURS,
  payload: fromCache
})

export const getAllColoursSuccess = colours => ({
  type: GET_COLOURS_SUCCESS,
  payload: colours,
})

export const getAllColoursFail = error => ({
  type: GET_COLOURS_FAIL,
  payload: error,
})

export const getAllSuppliers = (fromCache) => ({
  type: GET_SUPPLIERS,
  payload: fromCache
})

export const getAllSuppliersSuccess = suppliers => ({
  type: GET_SUPPLIERS_SUCCESS,
  payload: suppliers,
})

export const getAllSuppliersFail = error => ({
  type: GET_SUPPLIERS_FAIL,
  payload: error,
})

export const getAllCustomers = (fromCache) => ({
  type: GET_ALL_CUSTOMERS,
  payload: fromCache
})

export const getAllCustomersSuccess = customers => ({
  type: GET_ALL_CUSTOMERS_SUCCESS,
  payload: customers,
})

export const getAllCustomersFail = error => ({
  type: GET_ALL_CUSTOMERS_FAIL,
  payload: error,
})

export const getAllEmployees = () => ({
  type: GET_ALL_EMPLOYEES,
})

export const getAllEmployeesSuccess = employees => ({
  type: GET_ALL_EMPLOYEES_SUCCESS,
  payload: employees,
})

export const getAllEmployeesFail = error => ({
  type: GET_ALL_EMPLOYEES_FAIL,
  payload: error,
})

export const getAllBanks = () => ({
  type: GET_ALL_BANKS,
})

export const getAllBanksSuccess = banks => ({
  type: GET_ALL_BANKS_SUCCESS,
  payload: banks,
})

export const getAllBanksFail = error => ({
  type: GET_ALL_BANKS_FAIL,
  payload: error,
})

export const getAllBrands = (fromCache) => ({
  type: GET_BRANDS,
  payload: fromCache
})

export const getAllBrandsSuccess = brands => ({
  type: GET_BRANDS_SUCCESS,
  payload: brands,
})

export const getAllBrandsFail = error => ({
  type: GET_BRANDS_FAIL,
  payload: error,
})

export const getAllTaxes = (fromCache) => ({
  type: GET_TAXES,
  payload: fromCache
})

export const getAllTaxesSuccess = taxes => ({
  type: GET_TAXES_SUCCESS,
  payload: taxes,
})

export const getAllTaxesFail = error => ({
  type: GET_TAXES_FAIL,
  payload: error,
})

export const getAllManufacturers = (fromCache) => ({
  type: GET_MANUFACTURERS,
  payload: fromCache
})

export const getAllManufacturersSuccess = manufacturers => ({
  type: GET_MANUFACTURERS_SUCCESS,
  payload: manufacturers,
})

export const getAllManufacturersFail = error => ({
  type: GET_MANUFACTURERS_FAIL,
  payload: error,
})

export const getAllUnits = (fromCache) => ({
  type: GET_UNITS,
  payload: fromCache
})

export const getAllUnitsSuccess = units => ({
  type: GET_UNITS_SUCCESS,
  payload: units,
})

export const getAllUnitsFail = error => ({
  type: GET_UNITS_FAIL,
  payload: error,
})

export const getAllCoas = (fromCache) => ({
  type: GET_ALLCOA,
  payload: fromCache
})

export const getAllCoasSuccess = coas => ({
  type: GET_ALLCOA_SUCCESS,
  payload: coas,
})

export const getAllCoasFail = error => ({
  type: GET_ALLCOA_FAIL,
  payload: error,
})


export const getAllProducts = () => ({
  type: GET_ALL_PRODUCTS,
})

export const getAllProductsSuccess = products => ({
  type: GET_ALL_PRODUCTS_SUCCESS,
  payload: products,
})

export const getAllProductsFail = error => ({
  type: GET_ALL_PRODUCTS_FAIL,
  payload: error,
})

export const getProductForEdit = productid => ({
  type: GET_PRODUCT_FOR_EDIT,
  productid
})

export const getProductForEditSuccess = product => ({
  type: GET_PRODUCT_FOR_EDIT_SUCCESS,
  payload: product
})

export const getProductForEditFail = error => ({
  type: GET_PRODUCT_FOR_EDIT_FAIL,
  payload: error,
})

export const getAllHSNs = (fromCache) => ({
  type: GET_HSNS,
  payload: fromCache
})

export const getAllHSNsSuccess = hsns => ({
  type: GET_HSNS_SUCCESS,
  payload: hsns,
})

export const setTimeCounter = timecounter => ({
  type: SET_TIMER,
  payload: timecounter,
})

export const getAllHSNsFail = error => ({
  type: GET_HSNS_FAIL,
  payload: error,
})

export const resetErrorAndResp = () => ({
  type: RESET_ERROR_AND_RESP,
})

export const getCategoriesAndSubCategories = (fromCache) => ({
  type: GET_CATEGORIES_SUBCATEGORIES,
  payload: fromCache
})

export const getCategoriesAndSubCategoriesSuccess = categories => ({
  type: GET_CATEGORIES_SUBCATEGORIES_SUCCESS,
  payload: categories,
})

export const getCategoriesAndSubCategoriesFail = error => ({
  type: GET_CATEGORIES_SUBCATEGORIES_FAIL,
  payload: error,
})

export const addNewItem = (item, type) => {
  return {
    type: ADD_NEW_ITEM,
    payload: { item, type },
  }
}

export const addNewItemSuccess = response => {
  return {
    type: ADD_NEW_ITEM_SUCCESS,
    payload: response,
  }
}

export const addNewItemFail = error => {
  return {
    type: ADD_NEW_ITEM_FAIL,
    payload: error,
  }
}

export const addNewMajorItem = (item, type) => {
  return {
    type: ADD_NEW_MAJOR_ITEM,
    payload: { item, type },
  }
}

export const addNewMajorItemSuccess = response => {
  return {
    type: ADD_NEW_MAJOR_ITEM_SUCCESS,
    payload: response,
  }
}

export const addNewMajorItemFail = error => {
  return {
    type: ADD_NEW_MAJOR_ITEM_FAIL,
    payload: error,
  }
}

export const editItem = (item, type) => {
  return {
    type: EDIT_ITEM,
    payload: { item, type },
  }
}

export const editItemSuccess = response => {
  return {
    type: EDIT_ITEM_SUCCESS,
    payload: response,
  }
}

export const editItemFail = error => {
  return {
    type: EDIT_ITEM_FAIL,
    payload: error,
  }
}

export const deleteItem = (item, type) => {
  return {
    type: DELETE_ITEM,
    payload: { item, type },
  }
}

export const deleteItemSuccess = response => {
  return {
    type: DELETE_ITEM_SUCCESS,
    payload: response,
  }
}

export const deleteItemFail = error => {
  return {
    type: DELETE_ITEM_FAIL,
    payload: error,
  }
}